<template>
<div
  :class="['bg-'+backgroundColor, heightClass]"
  class="relative rounded overflow-hidden shadow">
  <!-- Barra de progreso -->
  <div
    :class="['bg-'+color]"
    class="float-left h-full"
    :style="{ width: progress + '%' }"
    style="-webkit-transition:width 1s ease-in-out;-moz-transition:width 1s ease-in-out;-o-transition:width 1s ease-in-out;transition:width 1s ease-in-out"
  ></div>
  <!-- Etiqueta -->
  <div v-if="showPercentage || showStep || onlyStep"
    class="float-left absolute inset-0 font-bold flex items-center justify-center"
    :class="{ 'text-grey-darkest': (progress <= 55), 'text-grey-lightest': (progress > 55) }"
    style="font-size:0.65rem;line-height:1rem"
  >
    {{ label }}
  </div>
</div>
</template>

<script>
export default {
  name: 'progress-bar',

  props: {
    step: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    showPercentage: { type: Boolean, default: true },
    showStep: { type: Boolean, default: false },
    onlyStep: { type: Boolean, default: false },
    color: { type: String, default: 'green' },
    backgroundColor: { type: String, default: 'grey-lighter' },
    size: { type: String, default: 'normal' },
    // Decimales mostrados en el label (% del progreso). Por defecto 0 para
    // mantener el comportamiento histórico (entero). Pasar 2 cuando se
    // quieran ver decimales (p. ej. avance planificado fino).
    decimals: { type: Number, default: 0 }
  },

  data: () => ({
    progress: 0,
    label: '',
  }),

  computed: {
    heightClass() {
      if (this.size === 'normal') {
        return 'h-4'
      } else if (this.size === 'small') {
        return 'h-2'
      } else if (this.size === 'large') {
        return 'h-6'
      }
    },
  },

  watch: {
    step() {
      this.calculateProgress()
    },
    decimals() {
      this.calculateProgress()
    },
    progress(value) {
      this.applyLabel(value)
    },
  },

  mounted() {
    this.calculateProgress()
  },

  methods: {
    calculateProgress() {
      const raw = (this.step * 100) / this.max
      this.progress = this.decimals > 0
        ? Number(raw.toFixed(this.decimals))
        : parseInt(Math.round(raw))
      this.applyLabel(this.progress)
    },

    applyLabel(value) {
      if (this.onlyStep) {
        const step = Number(this.step)
        this.label = this.decimals > 0 && Number.isFinite(step)
          ? step.toFixed(this.decimals)
          : this.step
        return
      }
      if (this.showPercentage) {
        const number = Number(value)
        this.label = (this.decimals > 0 && Number.isFinite(number)
          ? number.toFixed(this.decimals)
          : value) + '%'
        return
      }
      if (this.showStep) {
        this.label = value + '/' + this.max
        return
      }
      this.label = ''
    }
  },

};
</script>
